<script setup lang="ts">
defineEmits<{
    close: [];
}>();
</script>
<template>
    <div
        class="bg-chip hover:bg-chip-hover flex h-8 w-fit flex-row items-center justify-center gap-2 rounded-full px-4"
    >
        <span>
            <slot />
        </span>
        <span data-test="base-chip-dismiss" class="text-xs hover:cursor-pointer" @click="$emit('close')"> X </span>
    </div>
</template>
